var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confirmWrap"},[_c('div',{attrs:{"id":"top-pattern"}}),_vm._v(" "),_c('div',{attrs:{"id":"wrapper"}},[_c('h2',[_vm._v("You're subscribed!")]),_vm._v(" "),_c('p',[_c('img',{attrs:{"src":"/static/assets/images/tick.jpg","height":"92"}})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e5fdcc1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Confirm.vue
// module id = null
// module chunks = 